/**
 * Created by jiachenpan on 16/11/18.
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime (time, option) {
  // time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function timeTohhmmss (seconds) {
  if (typeof seconds === 'string' && seconds.indexOf(':') > -1) return seconds
  var hh
  var mm
  var ss
  if (seconds == null || seconds <= 0) {
    return '00:00:00'
  }
  hh = seconds / 3600 | 0
  seconds = parseInt(seconds) - hh * 3600
  if (parseInt(hh) < 10) {
    hh = '0' + hh
  }
  mm = seconds / 60 | 0
  ss = parseInt(seconds) - mm * 60
  if (parseInt(mm) < 10) {
    mm = '0' + mm
  }
  if (ss < 10) {
    ss = '0' + ss
  }
  return hh + ':' + mm + ':' + ss
}

export function hhmmssTotime (time) {
  const formatTime = time.split(':')
  const seconds = formatTime.length === 3
    ? Number(formatTime[0] * 3600) + Number(formatTime[1] * 60) + Number(formatTime[2])
    : Number(formatTime[0] * 60) + Number(formatTime[1])
  return seconds
}
